var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.544 14.616l.279-.604-.28.604a.85.85 0 001.207-.772V2.1a.85.85 0 00-.85-.85H2.1a.85.85 0 00-.85.85v11.744a.85.85 0 001.206.772l-.314-.681.314.68L6 12.98l3.544 1.636z",
    stroke: "#12385C",
    strokeWidth: 1.5
  })));
}
export default SvgSave;